import { ObjectValuesType } from 'addiction-components';

export const MenuSelected = {
	MEDIA_LIBRARY: '/media-library',
	MEDIA_FEATURE: '/media-library/features',
	LMS_FEATURE: '/lms/features',
} as const;
export type MenuSelected = ObjectValuesType<typeof MenuSelected>;
